import { render, staticRenderFns } from "./ModalTestQuestion.vue?vue&type=template&id=0ad3f91e&scoped=true&"
import script from "./ModalTestQuestion.vue?vue&type=script&lang=js&"
export * from "./ModalTestQuestion.vue?vue&type=script&lang=js&"
import style0 from "./ModalTestQuestion.vue?vue&type=style&index=0&id=0ad3f91e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad3f91e",
  null
  
)

export default component.exports